import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  Bounds,
  CropperSettings,
  ImageCropperComponent,
} from "ng2-img-cropper";
import * as _ from "lodash";
import { Types, WidthHeight } from "../../models/picture/types";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-picture-cropper",
  templateUrl: "./picture-cropper.component.html",
  styleUrls: ["./picture-cropper.component.scss"],
})
export class PictureCropperComponent implements OnInit {
  @Input() data: any;
  @Input() format: string;
  @Input() url: string;
  @Input() src: string;
  @Input() editMode: boolean;
  @Input() is4K: boolean;

  cropperSettings: CropperSettings;
  @ViewChild("cropper") cropper: ImageCropperComponent;
  croppedWidth: number;
  croppedHeight: number;
  image: any;
  ready: boolean;
  edition: boolean;
  waitingCropper: boolean;

  types: Types;
  widthHeight: WidthHeight;
  hasCustomPosition: boolean;
  customXPosition: number;
  customYPosition: number;

  /**
   * Initialize variables
   */
  constructor(private store: Store<any>) {
    this.ready = false;
    this.edition = false;
    this.waitingCropper = true;

    this.store.select("pictureFormatsState").subscribe((state: any) => {
      this.types = state.types;
    });
  }

  /**
   * Check if a source exist, else call the loadImage process
   */
  ngOnInit() {
    if (!this.src) {
      this.loadImage();
    }
  }

  /**
   * If in edit mode, load the image data and init the cropper
   */
  loadImage() {
    
    let type = this.is4K ? this.types.type_4k : this.types.type_hd;
    this.widthHeight = type[this.format];
    
    if (this.editMode) {
      this.edition = true;
      this.image = new Image();
      this.image.crossOrigin = "Anonymous";
      this.image.src = this.url;
      this.image.onload = () => {
        this.data = this.image;
        this.initCropper();
      };
    }
  }

  /**
   * Define all the cropper settings
   */
  initCropper() {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.noFileInput = true;

    this.cropperSettings.croppedWidth = this.widthHeight.width;
    this.cropperSettings.croppedHeight = this.widthHeight.height;
    this.cropperSettings.minWidth = this.widthHeight.width;
    this.cropperSettings.minHeight = this.widthHeight.height;
    this.cropperSettings.width = this.widthHeight.width;
    this.cropperSettings.height = this.widthHeight.height;

    this.cropperSettings.canvasWidth = 700;
    this.cropperSettings.canvasHeight = 450;

    this.cropperSettings.rounded = false;
    this.cropperSettings.keepAspect = true;

    this.cropperSettings.cropperDrawSettings.strokeColor =
      "rgba(255,255,255,1)";
    this.cropperSettings.cropperDrawSettings.strokeWidth = 2;

    this.ready = true;
    const interval = setInterval(() => {
      if (this.cropper) {
        if (!this.cropper.cropper.isImageSet() && this.data) {
          this.cropper.setImage(this.data);
        } else if (
          this.cropper.cropper.isImageSet() &&
          this.data &&
          this.hasCustomPosition
        ) {
          let bounds = new Bounds();
          let previousBounds = this.cropper.cropper.getBounds();

          // Calculate (x => 0/700; y => 0/460)
          // Clamp is Min/Max picture crop
          let cropper = _.cloneDeep(this.cropper.cropper);
          let clamps = {
            top: cropper.minYClamp,
            bottom: cropper.maxYClamp,
            left: cropper.minXClamp,
            right: cropper.maxXClamp,
          };

          // Get difference
          let axisXDifference = previousBounds.right - previousBounds.left;
          let axisYDifference = previousBounds.bottom - previousBounds.top;

          bounds.left =
            this.customXPosition - axisXDifference / 2 + clamps.left;
          bounds.right =
            this.customXPosition + axisXDifference / 2 + clamps.left;

          bounds.top = this.customYPosition - axisYDifference / 2 + clamps.top;
          bounds.bottom =
            this.customYPosition + axisYDifference / 2 + clamps.top;

          // recalculate if out of bound
          if (bounds.left < clamps.left) {
            bounds.left = clamps.left;
            bounds.right = clamps.left + axisXDifference;
          }

          if (bounds.right > clamps.right) {
            bounds.left = clamps.right - axisXDifference;
            bounds.right = clamps.right;
          }

          if (bounds.top < clamps.top) {
            bounds.top = clamps.top;
            bounds.bottom = clamps.top + axisYDifference;
          }

          if (bounds.bottom > clamps.bottom) {
            bounds.top = clamps.bottom - axisYDifference;
            bounds.bottom = clamps.bottom;
          }

          this.cropper.cropper.setBounds(bounds);
          this.cropped(bounds);
          this.hasCustomPosition = false;
        } else if (this.cropper.cropper.isImageSet() && this.data) {
          this.cropper.setImage(this.data);
          this.image = this.data.image;
        }

        if (
          this.cropper.cropper.isImageSet() &&
          this.data &&
          !this.hasCustomPosition
        ) {
          clearInterval(interval);
        }
      }
    }, 100);
  }

  /**
   * Listen the crop event and change the image data according to crop settings
   * @param {Bounds} bounds
   */
  cropped(bounds: Bounds) {
    this.croppedHeight = bounds.bottom - bounds.top;
    this.croppedWidth = bounds.right - bounds.left;
    this.image = this.data.image;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/picture-cropper/picture-cropper.component.ts